import axios from '../../plugins/axios'

export const listEstimatedSales = (_, { params } = {} ) => {
  return axios.get('/estimated-data/estimated-sale/', { params })
    .catch(err => err.response)
}

export const listEstimatedProduction = (_, { params } = {} ) => {
  return axios.get('/estimated-data/estimated-production/', { params })
    .catch(err => err.response)
}

export const listEstimatedCost= (_, { params } = {} ) => {
  return axios.get('/estimated-data/estimated-cost/', { params })
    .catch(err => err.response)
}

export const exportEstimatedSales = (_, { params } = {} ) => {
  return axios.get('/estimated-data/estimated-sale/export/', { params, responseType: 'blob' })
    .catch(err => err.response)
}

export const exportEstimatedProduction = (_, { params } = {} ) => {
  return axios.get('/estimated-data/estimated-production/export/', { params, responseType: 'blob' })
    .catch(err => err.response)
}

export const exportEstimatedCost= (_, { params } = {} ) => {
  return axios.get('/estimated-data/estimated-cost/export/', { params, responseType: 'blob' })
    .catch(err => err.response)
}

export const getMonthlyEstimate = (_, { planId } = {} ) => {
  return axios.get(`/plan/${planId}/monthly_estimate/`)
    .catch(err => err.response)
}

// Importar datos planificados desde Excel
export const importEstimatedSales = (_, { planId, data } = {} ) => {
  return axios.post(`/plan/sale-plan/${planId}/import_estimated_data/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
    .catch(err => err.response)
}

export const importEstimatedProduction = (_, { planId, data } = {} ) => {
  return axios.post(`/plan/production-plan/${planId}/import_estimated_data/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
    .catch(err => err.response)
}

export const importEstimatedCost = (_, { planId, data } = {} ) => {
  return axios.post(`/plan/cost-plan/${planId}/import_estimated_data/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
    .catch(err => err.response)
}

// Guardar datos planificados desde la tabla editable (reemplaza el conjunto)
export const saveEstimatedSales = (_, { planId, data } = {} ) => {
  return axios.post(`/plan/sale-plan/${planId}/save_estimated_data/`, data)
    .catch(err => err.response)
}

export const saveEstimatedProduction = (_, { planId, data } = {} ) => {
  return axios.post(`/plan/production-plan/${planId}/save_estimated_data/`, data)
    .catch(err => err.response)
}

export const saveEstimatedCost = (_, { planId, data } = {} ) => {
  return axios.post(`/plan/cost-plan/${planId}/save_estimated_data/`, data)
    .catch(err => err.response)
}